import * as React from "react";
const ElchemySVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={224}
    height={94}
    fill="none"
    {...props}
  >
    <g filter="url(#a)">
      <mask id="b" fill="#fff">
        <path d="M4 26.218c0-8.188 0-12.282 1.593-15.41a14.62 14.62 0 0 1 6.39-6.388c3.127-1.594 7.22-1.594 15.408-1.594H193.61c8.187 0 12.281 0 15.409 1.594a14.626 14.626 0 0 1 6.389 6.389C217 13.936 217 18.029 217 26.218v35.336c0 8.187 0 12.281-1.593 15.409a14.626 14.626 0 0 1-6.389 6.389c-3.128 1.593-7.222 1.593-15.409 1.593H27.391c-8.187 0-12.281 0-15.408-1.593a14.62 14.62 0 0 1-6.39-6.39C4 73.836 4 69.743 4 61.555V26.218Z" />
      </mask>
      <path
        fill="#FAFAFA"
        d="M4 26.218c0-8.188 0-12.282 1.593-15.41a14.62 14.62 0 0 1 6.39-6.388c3.127-1.594 7.22-1.594 15.408-1.594H193.61c8.187 0 12.281 0 15.409 1.594a14.626 14.626 0 0 1 6.389 6.389C217 13.936 217 18.029 217 26.218v35.336c0 8.187 0 12.281-1.593 15.409a14.626 14.626 0 0 1-6.389 6.389c-3.128 1.593-7.222 1.593-15.409 1.593H27.391c-8.187 0-12.281 0-15.408-1.593a14.62 14.62 0 0 1-6.39-6.39C4 73.836 4 69.743 4 61.555V26.218Z"
        shapeRendering="crispEdges"
      />
      <path
        fill="#EF4136"
        fillOpacity={0.2}
        d="M4 2.826h213H4Zm213 67.5c0 8.747-7.091 15.837-15.838 15.837H19.838C11.09 86.163 4 79.073 4 70.325c0 7.402 6.545 13.402 14.62 13.402h183.76c8.075 0 14.62-6 14.62-13.402ZM4 84.945V2.825v82.12Zm213-82.12v82.12-82.12Z"
        mask="url(#b)"
      />
      <path
        fill="#040919"
        d="M33.75 41.712v7.806h14.602v5.402H27.395V23.148h20.507v5.402H33.749v7.76h13.478v5.402H33.749ZM84.144 49.067c-1.622 3.767-5.003 6.308-10.186 6.308-7.482 0-11.224-4.72-11.224-11.8 0-7.081 3.742-11.802 11.224-11.802 4.822 0 8.159 2.225 9.87 5.447l-5.498 3.313c-1.081-2.224-2.704-3.36-4.372-3.36-3.29 0-4.868 2.497-4.868 6.4 0 3.904 1.577 6.4 4.868 6.4 1.713 0 3.515-1.18 4.417-3.495l5.77 2.589ZM93.523 54.92h-6.355V21.787h6.355V34.36c1.713-1.77 3.606-2.588 6.265-2.588 4.507 0 7.167 2.769 7.167 8.578v14.57h-6.354V40.486c0-2.314-1.263-3.314-3.156-3.314-2.344 0-3.922 1.997-3.922 7.127v10.62ZM59.227 44.3v10.62H52.87V21.787h6.355V44.3ZM131.663 53.149c-3.11 1.498-6.131 2.224-8.925 2.224-7.663 0-12.394-4.492-12.394-11.8 0-7.081 3.786-11.802 11.222-11.802 7.032 0 10.502 4.54 10.502 10.803v3.359h-15.144c.632 2.541 2.479 4.04 5.949 4.04 1.894 0 4.147-.59 6.762-1.862l2.028 5.038Zm-14.605-12.435h8.61c-.18-2.452-1.848-3.541-4.102-3.541-2.388 0-3.876 1.316-4.508 3.541ZM153.113 35.373c1.577-2.314 4.057-3.54 6.851-3.54 4.868 0 8.294 2.632 8.294 8.08V54.98h-6.356v-15.16c0-1.816-1.442-2.589-2.659-2.589-2.659 0-4.012 2.09-4.012 5.81v11.937h-6.354V40.093c0-1.952-1.398-2.86-2.84-2.86-2.253 0-3.831 2.089-3.831 5.856V54.98h-6.354V32.286h6.354v2.27c1.217-1.86 2.705-2.724 4.912-2.724 2.66 0 4.868 1.271 5.995 3.54ZM185.21 52.882l-8.476 19.698h-6.851l8.113-20.008-8.113-20.289h6.896l8.431 20.599Z"
      />
      <path
        fill="url(#c)"
        d="m182.254 45.583 4.902-13.3h6.805l-5.688 13.31-6.019-.01Z"
      />
    </g>
    <defs>
      <linearGradient
        id="c"
        x1={182.254}
        x2={193.961}
        y1={38.937}
        y2={38.937}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F15B2A" />
        <stop offset={1} stopColor="#EF4137" />
      </linearGradient>
      <filter
        id="a"
        width={223.473}
        height={92.592}
        x={0.26}
        y={0.582}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={1.496} dy={2.992} />
        <feGaussianBlur stdDeviation={2.618} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0156863 0 0 0 0 0.0352941 0 0 0 0 0.0980392 0 0 0 0.06 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_997_14381"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_997_14381"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default ElchemySVG;
